{
	"title": "Voorraad",
	"description": "De voorraad per variant per locatie. Elke wijziging is een mutatie met een reden.",
	"searchLabel": "Zoek op naam, SKU of EAN",
	"empty": "Er zijn nog geen varianten.",
	"quickLink": "Snelle correctie",
	"locationsLink": "Locaties",
	"column": {
		"variant": "Variant",
		"total": "Totaal",
		"available": "Beschikbaar",
		"status": "Status"
	},
	"filter": {
		"label": "Voorraad",
		"low": "Bijna op",
		"out": "Op",
		"activeLabel": "Producten",
		"activeOnly": "Alleen in de shop"
	},
	"level": {
		"out": "Op",
		"low": "Bijna op",
		"ok": "Op voorraad",
		"composed": "Samengesteld"
	},
	"inactive": "Niet actief",
	"ean": "EAN {{ean}}",
	"variant": {
		"product": "Naar het product",
		"facts": "Gegevens",
		"sku": "SKU",
		"ean": "EAN",
		"noEan": "Geen EAN",
		"active": "In de verkoop",
		"yes": "Ja",
		"no": "Nee",
		"levels": "Per locatie",
		"levelsDescription": "Beschikbaar is de voorraad min wat voor openstaande orders is gereserveerd.",
		"location": "Locatie",
		"quantity": "Voorraad",
		"default": "standaard",
		"total": "Totaal"
	},
	"book": {
		"title": "Mutatie boeken",
		"description": "Voorraad zet je nooit direct: je boekt wat er gebeurde.",
		"kind": "Soort",
		"location": "Locatie",
		"quantity": "Aantal",
		"delta": "Verschil",
		"deltaDescription": "Wat erbij komt of eraf gaat, bijvoorbeeld -2 als er twee kapot zijn. Nu {{quantity}} op deze locatie.",
		"quantityReceipt": "Hoeveel stuks er binnenkwamen.",
		"quantityTransfer": "Hoeveel stuks naar de fulfilmentpartij gingen. Nu {{quantity}} op deze locatie.",
		"reason": "Reden",
		"reasonOptional": "Reden (optioneel)",
		"reasonDescription": "Waarom, zodat het later nog uit te leggen is.",
		"submit": "Boeken",
		"booked": "Geboekt: nu {{quantity}} op {{location}}",
		"deltaZero": "Een correctie verandert de voorraad: vul iets anders dan 0 in."
	},
	"kind": {
		"label": "Soort",
		"receipt": "Ontvangst",
		"sale": "Verkoop",
		"correction": "Correctie",
		"transfer_to_fulfilment": "Naar fulfilment",
		"return": "Retour"
	},
	"history": {
		"title": "Mutatiehistorie",
		"description": "Elke wijziging van de voorraad, de nieuwste bovenaan.",
		"empty": "Er is nog niets geboekt.",
		"when": "Wanneer",
		"kind": "Soort",
		"change": "Mutatie",
		"after": "Daarna",
		"where": "Van en naar",
		"who": "Wie",
		"why": "Reden",
		"system": "Systeem",
		"intoLocation": "Naar {{location}}",
		"fromLocation": "Van {{location}}",
		"toFulfilment": "{{location}} → fulfilmentpartij",
		"fromCustomer": "Klant → {{location}}"
	},
	"error": {
		"insufficient": "Zoveel ligt er niet op deze locatie. Voorraad kan niet onder 0.",
		"variantNotFound": "Deze variant bestaat niet (meer).",
		"locationNotFound": "Deze locatie bestaat niet (meer).",
		"composedBundle": "Deze bundel is samengesteld: hij heeft geen eigen voorraad. Boek op de onderdelen.",
		"productArchived": "Het product is gearchiveerd. Zet het product eerst terug om voorraad te boeken."
	},
	"quick": {
		"title": "Snelle correctie",
		"description": "Zoek of scan een variant en tel bij of af.",
		"searchLabel": "Naam, SKU of EAN",
		"searchPlaceholder": "Typ of scan…",
		"hint": "Typ een deel van de naam, of de SKU of EAN.",
		"none": "Niets gevonden voor “{{search}}”.",
		"more": "Er zijn meer treffers: typ verder om te verfijnen.",
		"select": "{{name}} kiezen",
		"back": "Andere variant",
		"now": "Nu",
		"after": "Wordt",
		"minus": "Eén eraf",
		"plus": "Eén erbij",
		"change": "Verschil",
		"reason": "Reden",
		"reasons": {
			"count": "Telling",
			"broken": "Kapot",
			"missing": "Zoekgeraakt",
			"found": "Teruggevonden"
		},
		"reasonOther": "Andere reden",
		"save": "Opslaan",
		"saved": "Opgeslagen: {{name}} staat nu op {{quantity}}",
		"history": "Historie bekijken",
		"reasonMissing": "Kies of typ een reden om op te slaan.",
		"location": "Locatie",
		"changeValue": "Verschil {{delta}}"
	},
	"panel": {
		"link": "Voorraad en historie",
		"loading": "Voorraad laden…",
		"failed": "De voorraad kon niet worden geladen."
	},
	"composed": {
		"title": "Samengestelde bundel",
		"description": "Deze bundel heeft geen eigen voorraad: hoeveel er te koop zijn volgt uit de voorraad van de onderdelen. Boek ontvangsten en correcties op de onderdelen, of maak de bundel voorverpakt in het product.",
		"link": "Naar de onderdelen"
	},
	"archived": {
		"title": "Gearchiveerd product",
		"description": "Zolang het product gearchiveerd is, boek je hier geen voorraad. Wat orders terugbrengen (een annulering, een terugbetaling) komt wel binnen. Zet het product eerst terug om voorraad te boeken.",
		"link": "Naar het product"
	},
	"help": {
		"list": {
			"title": "Voorraadlijst",
			"area": "Voorraad",
			"short": "Elke variant met zijn voorraad per locatie, het totaal en wat beschikbaar is. Klik op een variant om een voorraadmutatie te boeken of de historie te zien. Tellen in het magazijn doe je met Snelle correctie.",
			"terms": [
				"location:location",
				"stock:available",
				"stock:movement",
				"stock:quick",
				"stock:levelFilter",
				"stock:composedBundle"
			]
		},
		"levelFilter": {
			"title": "Bijna op en Op",
			"area": "Voorraad",
			"short": "Zo vind je wat je moet bijbestellen. Het filter telt de voorraad van alle locaties samen; reserveringen tellen hier niet mee.",
			"choices": [
				{
					"name": "Bijna op",
					"text": "Van 1 tot en met de grens die je per product instelt, bij Basis. Grens 0: nooit bijna op."
				},
				{
					"name": "Op",
					"text": "0 stuks, op alle locaties samen."
				},
				{
					"name": "Alleen in de shop",
					"text": "Zonder de varianten en producten die uit staan."
				}
			],
			"warning": "Een samengestelde bundel staat bij geen van beide: hij heeft geen eigen voorraad.",
			"terms": ["stock:reservation", "stock:composedBundle", "product:active"]
		},
		"available": {
			"title": "Beschikbaar",
			"area": "Voorraad",
			"short": "Wat je nog kunt verkopen: de voorraad min reserveringen, van alle locaties samen. Dat ziet de klant: bij 0 beschikbaar staat er in de shop Uitverkocht.",
			"warning": "Op de productpagina ziet de klant niet hoeveel er nog zijn. Kiest de klant er meer en tikt op In de mand, dan zegt de shop: “Er zijn er nog maar 2 beschikbaar.” De levertijd blijft gelijk: wat uitverkocht is, kan niemand bestellen.",
			"terms": ["stock:reservation", "location:location"]
		},
		"reservation": {
			"title": "Reservering",
			"area": "Voorraad",
			"short": "Bij een bestelling houdt de shop de voorraad vast voor de order, tot die betaald is. Betaald wordt het een verkoop. Komt de betaling niet, dan vervalt de reservering en is de voorraad weer beschikbaar.",
			"choices": [
				{
					"name": "Online betalen",
					"text": "iDEAL, Bancontact, kaart of PayPal: vervalt na 30 minuten zonder betaling."
				},
				{
					"name": "Overboeking",
					"text": "Vervalt na 7 dagen zonder betaling."
				},
				{
					"name": "Op rekening",
					"text": "Vervalt niet: de voorraad is meteen verkocht."
				}
			],
			"warning": "Betaalt een klant toch nog na het vervallen, dan neemt de shop de voorraad opnieuw, als die er nog is. De order vraagt je dan de voorraad te controleren voordat je verzendt.",
			"terms": ["stock:available", "stock:movement"]
		},
		"movement": {
			"title": "Voorraadmutatie",
			"area": "Voorraad",
			"short": "Elke wijziging van de voorraad is een mutatie: wat er gebeurde, op welke locatie, door wie en waarom. Je zet voorraad nooit direct; zo is elke stand later te verklaren.",
			"choices": [
				{
					"name": "Ontvangst",
					"text": "Er kwam een levering binnen. Die boek je zelf."
				},
				{
					"name": "Verkoop",
					"text": "Een order is betaald. Die boekt de shop zelf."
				},
				{
					"name": "Correctie",
					"text": "Een telling die afwijkt, of iets kapot of zoek. Altijd met een reden."
				},
				{
					"name": "Naar fulfilment",
					"text": "Voorraad die je naar de fulfilmentpartij stuurt; hij gaat van deze locatie af."
				},
				{
					"name": "Retour",
					"text": "Een terugbetaling met Voorraad terugboeken aan boekt hem, op naam van wie terugbetaalde."
				}
			],
			"terms": ["location:location", "stock:reservation", "stock:book"]
		},
		"variant": {
			"title": "Voorraadpagina van een variant",
			"area": "Voorraad",
			"short": "De voorraad van één variant: hoeveel er per locatie ligt, een mutatie boeken en de historie. Prijs, SKU en de rest bewerk je in het product, met Naar het product.",
			"terms": ["stock:levels", "stock:book", "stock:history", "product:variants"]
		},
		"levels": {
			"title": "Per locatie",
			"area": "Voorraad › Variant",
			"short": "Hoeveel stuks er op elke locatie liggen, de standaardlocatie eerst. Totaal telt de locaties op; beschikbaar is dat totaal min de reserveringen.",
			"terms": ["location:location", "stock:available", "stock:reservation", "stock:levelFilter"]
		},
		"book": {
			"title": "Mutatie boeken",
			"area": "Voorraad › Variant",
			"short": "Je boekt wat er gebeurde, en de voorraad volgt. Kies de soort, de locatie en het aantal. Een correctie vraagt altijd een reden.",
			"choices": [
				{
					"name": "Ontvangst",
					"text": "Er komt voorraad bij: een levering."
				},
				{
					"name": "Correctie",
					"text": "Het verschil, met een min als het minder is: -2 als er twee kapot zijn."
				},
				{
					"name": "Naar fulfilment",
					"text": "Voorraad die naar de fulfilmentpartij gaat; hij gaat van deze locatie af."
				}
			],
			"warning": "Voorraad kan niet onder 0. Een verkoop en een retour boek je hier niet: die komen uit orders en terugbetalingen.",
			"terms": ["stock:movement", "location:location", "stock:quickCorrection"]
		},
		"history": {
			"title": "Mutatiehistorie",
			"area": "Voorraad › Variant",
			"short": "Elke voorraadmutatie van deze variant, de nieuwste bovenaan: de soort, het verschil, de stand daarna, waar, wie en waarom. Systeem betekent dat de shop hem zelf boekte, zoals bij een betaalde order.",
			"terms": ["stock:movement"]
		},
		"facts": {
			"title": "Gegevens van de variant",
			"area": "Voorraad › Variant",
			"short": "De SKU en EAN om de variant te vinden of te scannen, en of hij in de verkoop is. Die wijzig je in het product.",
			"terms": ["product:sku", "product:variantActive"]
		},
		"composedBundle": {
			"title": "Samengestelde bundel",
			"area": "Voorraad",
			"short": "Een samengestelde bundel heeft geen eigen voorraad. Zijn beschikbaarheid komt uit de onderdelen: zoveel bundels als die toelaten. Met 1 wisser en 2 pakken per bundel, en 5 wissers en 6 pakken beschikbaar, zijn dat er 3.",
			"warning": "Je boekt dus niets op de bundel, maar op de onderdelen. Ligt hij kant-en-klaar in het magazijn, maak hem dan voorverpakt: dan heeft hij wel eigen voorraad.",
			"terms": ["bundle:components", "bundle:stockMode", "stock:available"]
		},
		"archived": {
			"title": "Gearchiveerd product",
			"area": "Voorraad",
			"short": "Een gearchiveerd product staat niet in de shop en niet in de voorraadlijst. Op zijn varianten boek je geen voorraad, tot je het product terugzet.",
			"warning": "Wat orders terugbrengen, zoals een annulering of een terugbetaling, komt wel binnen.",
			"terms": ["product:delete"]
		},
		"quick": {
			"title": "Snelle correctie",
			"area": "Voorraad",
			"short": "Voor je telefoon in het magazijn. Typ of scan een naam, SKU of EAN en tik de variant aan; een hele SKU of EAN opent hem meteen.",
			"terms": ["stock:quickCorrection", "product:sku"]
		},
		"quickCorrection": {
			"title": "Tellen en corrigeren",
			"area": "Voorraad › Snelle correctie",
			"short": "Tel wat er ligt en tik op − of + tot Wordt klopt. Kies een reden en sla op: dat boekt een correctie op deze locatie.",
			"warning": "Een betaalde order is al afgeboekt, ook als hij nog niet verzonden is. Tel stuks die klaarliggen voor een order dus niet mee.",
			"terms": ["stock:movement", "location:location"]
		}
	},
	"helpExample": {
		"sandbox": "Floorwipes XXL op de productpagina: met {{available}} beschikbaar.",
		"stock": "Voorraad",
		"reserved": "Gereserveerd",
		"quantity": "Klant kiest",
		"available": "Beschikbaar: {{count}}",
		"less": "{{what}}: één minder",
		"more": "{{what}}: één meer",
		"product": "Floorwipes XXL",
		"detail": "20 doekjes",
		"quick": {
			"animation": "Snelle correctie: 6 stuks staan geboekt, je telt er 4, tikt twee keer op min, kiest Telling en slaat op. Nu staat er 4.",
			"steps": {
				"count": "Je telt 4 stuks; Nu zegt 6.",
				"minus": "Tik twee keer op −: Wordt is 4.",
				"reason": "Kies een reden: Telling.",
				"save": "Opslaan boekt een correctie van −2."
			}
		}
	}
}
